
export default function IconError({ size = 20, ...rest }) {
  return (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 17" fill="none">
      <g clipPath="url(#clip0_2331_38519)">
        <path d="M9 0.5C4.58867 0.5 1 4.08867 1 8.5C1 12.9113 4.58867 16.5 9 16.5C13.4113 16.5 17 12.9113 17 8.5C17 4.08867 13.4113 0.5 9 0.5ZM8.33333 5.16667C8.33333 4.798 8.63133 4.5 9 4.5C9.36867 4.5 9.66667 4.798 9.66667 5.16667V9.16667C9.66667 9.53533 9.36867 9.83333 9 9.83333C8.63133 9.83333 8.33333 9.53533 8.33333 9.16667V5.16667ZM9 12.8333C8.54 12.8333 8.16667 12.46 8.16667 12C8.16667 11.54 8.54 11.1667 9 11.1667C9.46 11.1667 9.83333 11.54 9.83333 12C9.83333 12.46 9.46 12.8333 9 12.8333Z" fill="#CD0710"/>
      </g>
      <defs>
        <clipPath id="clip0_2331_38519">
          <rect width="20" height="16" fill="currentColor" transform="translate(0 0.5)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
